/*
 * Copyright (c) 2020. American Express Company
 */

import React from 'react';
import { ButtonPrimaryDark } from '@americanexpress/dls-react';
import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import './TabButton.scss';
import { TabButtonViewModel } from 'src/types/view-models/tab-button.view.model';
import Selectors from 'src/utils/selectors';

const TabButton = ({
    labels,
    current,
    className,
    icons,
    onClickLeft,
    onClickRight
}: TabButtonViewModel): JSX.Element => {
    const selectedLeft: string = labels[0] === current ? 'selected' : '';
    const selectedRight: string = labels[1] === current ? 'selected' : '';

    return (
        <div className={`tab-button ${className && className}`} key="tab-button" role="tablist">
            <ButtonPrimaryDark
                icon={icons?.[0]}
                className={'left-button ' + selectedLeft}
                key="left-button"
                aria-selected={labels[0] === current}
                role="tab"
                data-cy={Selectors.General.TAB_BUTTON}
                onClick={async () => {
                    if (!selectedLeft) {
                        await onClickLeft();
                    }
                }}
            >
                <Typography
                    variant={TypographyVariants.BODY_BOLD}
                    className="left-button-label"
                    key="left-button-label"
                >
                    {labels[0]}
                </Typography>
            </ButtonPrimaryDark>
            <ButtonPrimaryDark
                icon={icons?.[1]}
                className={'right-button ' + selectedRight}
                key="right-button"
                aria-selected={labels[1] === current}
                role="tab"
                data-cy={Selectors.General.TAB_BUTTON}
                onClick={async () => {
                    if (!selectedRight) {
                        await onClickRight();
                    }
                }}
            >
                <Typography
                    variant={TypographyVariants.BODY_BOLD}
                    className="right-button-label"
                    key="right-button-label"
                >
                    {labels[1]}
                </Typography>
            </ButtonPrimaryDark>
        </div>
    );
};

export default TabButton;
